/* Fabareeze: mobile scroll-hover (focused-row mode). Only the card row centered in the viewport shows its 2nd image (fabric close-up): a card needs >=55% of its media inside the middle band to gain .fb-inview, so adjacent rows peeking into the band stay on the model shot. Fades back as it leaves center. Desktop >=990px: inert (Dawn's native :hover applies). Handles cards added later by infinite scroll via MutationObserver. */
(function(){
  var mq = window.matchMedia('(max-width: 989px)');
  var RATIO = 0.55;
  var io = null;
  function observeAll(){
    if(!io) return;
    var els = document.querySelectorAll('.card-wrapper .media.media--hover-effect');
    for(var i=0;i<els.length;i++){ io.observe(els[i]); }
  }
  function setup(){
    if(io){ io.disconnect(); io = null; }
    var stale = document.querySelectorAll('.media--hover-effect.fb-inview');
    for(var i=0;i<stale.length;i++){ stale[i].classList.remove('fb-inview'); }
    if(!mq.matches || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function(entries){
      for(var i=0;i<entries.length;i++){
        var e = entries[i];
        e.target.classList.toggle('fb-inview', e.isIntersecting && e.intersectionRatio >= RATIO);
      }
    }, { rootMargin: '-32% 0px -32% 0px', threshold: [0, RATIO] });
    observeAll();
  }
  var mo = new MutationObserver(function(muts){
    if(!io) return;
    for(var i=0;i<muts.length;i++){
      if(muts[i].addedNodes.length){ observeAll(); return; }
    }
  });
  function start(){
    setup();
    mo.observe(document.body, {childList:true, subtree:true});
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); } else { start(); }
  if(mq.addEventListener){ mq.addEventListener('change', setup); }
})();
